<template>
  <div class="add-info">
    <div class="page_title flex_between">
      <span>{{ reportRoute.info_id | titleText }}</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div class="container">
      <div class="add-info-box">
        <el-form
          :model="infoForm"
          :rules="rules"
          ref="infoFormRef"
          label-width="100px"
          class="info-form"
        >
          <el-form-item
            label="标题:"
            prop="title"
          >
            <el-input
              v-model="infoForm.title"
              :disabled="isDisable"
              style="width:600px"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="内容简介:"
            prop="summary"
          >
            <el-input
              v-model="infoForm.summary"
              :disabled="isDisable"
              style="width:600px"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="资讯分类:"
            prop="category_id"
            class="info-type"
          >
            <el-select
              v-model="infoForm.category_id"
              clearable
              :disabled="isDisable"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.category_id"
                :label="item.category_name"
                :value="item.category_id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="图片上传:"
            class="icon_img"
            prop="pic"
          >
            <el-upload
              list-type="picture-card"
              :disabled="isDisable"
              :action="uploadUrl"
              :show-file-list="false"
              name="image"
              accept=".png,.jpeg,.jpg"
              ref="iconImgRef"
              class="box"
              :headers="uploadHeaders"
              :data="uploadExtraData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeUpload"
            >
              <img
                v-if="infoForm.pic_path"
                :src="infoForm.pic_path"
              />
              <div
                v-else
                class="icon-box"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div
                v-show="infoForm.pic_path"
                class="shadow column-center column"
              >
                <div>
                  <i
                    class="el-icon-delete"
                    @click.stop="delImg()"
                  ></i>
                </div>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="内容编辑:"
            required=""
            class="info-editor"
          >
            <wangeditorNew
              ref="editorBox"
              @changeCheck="changeCheck"
              :margins="margins"
              :style="previewDialog ? { opacity: 0 } : { opacity: 1 }"
            />
          </el-form-item>
          <el-form-item class="btn-box">
            <el-button
              type="primary"
              :disabled="isDisable"
              @click="submitForm('infoFormRef')"
            >保 存</el-button>
            <el-button
              @click="resetForm('infoFormRef')"
              :disabled="isDisable"
            >重 置</el-button>
            <el-button
              type="primary"
              @click="preview('infoFormRef')"
              :disabled="isDisable"
            >保存并预览</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 二维码 -->
    <el-dialog
      title="预览"
      :visible.sync="previewDialog"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :show-close="false"
      class="add-or-editor-plan-img qr-code"
      width="400px"
      center
    >
      <div
        id="qrcode"
        ref="qrcodeRef"
        style="margin:20px 0"
      ></div>
      <span slot="footer">
        <el-button
          type="primary"
          size="medium"
          @click="closePreview()"
        >关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import imgtext from '../../../../api/imgtext';
import constant from '@/service/common/constant';
import wangeditorNew from '../../wangeditorNew.vue';
import QRCode from 'qrcodejs2';
export default {
  components: {
    wangeditorNew
  },
  data() {
    return {
      infoForm: {
        title: '',
        summary: '',
        category_id: '',
        pic: '',
        pic_path: '',
        content: '',
        margins: 1
      },
      uploadExtraData: {
        img_type: 4,
        suffix: '.jpg'
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur'
          }
        ],
        summary: [
          { required: true, message: '请输入内容简介', trigger: 'blur' },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        category_id: [
          { required: true, message: '请选择资讯分类', trigger: 'change' }
        ]
      },
      dialogIcon: false,
      options: [],
      previewDialog: false,
      previewId: null,
      margins: 1
    };
  },
  filters: {
    titleText(val) {
      switch (val) {
        case '-1':
          return '添加资讯';
        default:
          return '编辑资讯';
      }
    }
  },
  computed: {
    reportRoute() {
      return this.$route.query;
    },
    isDisable() {
      return this.$route.query.status == 2 ? true : false;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return '/api/platform/upload/uploadFile';
      } else {
        return '/platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  mounted() {
    this.margins = 1;
    this.getOptions();
    this.init();
  },

  methods: {
    init() {
      if (this.reportRoute.info_id != -1) {
        this.infoForm = this.reportRoute;
        console.log(this.infoForm);
        this.infoForm.category_id = Number(this.infoForm.category_id);
        setTimeout(() => {
          this.$refs.editorBox.editor.setHtml(this.infoForm.content);
          this.margins = Number(this.infoForm.margins);
        }, 1000);
      }
    },
    // 获取资讯分类
    getOptions() {
      imgtext.getDoctorInfoCategoryList().then((res) => {
        let { list } = res.data;
        this.options = list;
      });
    },
    //获取边距
    changeCheck(value) {
      this.margins = value;
    },
    submitForm(formName) {
      this.infoForm.content = this.$refs.editorBox.editor.getHtml();
      this.infoForm.margins = this.margins;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.infoForm.content) {
            this.$message.error('请填写内容');
            return false;
          }
          let isAdd = this.reportRoute.info_id == -1 ? true : false;
          let params = isAdd
            ? this.infoForm
            : Object.assign(this.reportRoute, this.infoForm);
          if (isAdd) {
            imgtext.saveDoctorInfo(params).then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success('保存成功');
                this.back();
              }
            });
          } else {
            imgtext.editDoctorInfo(params).then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success('编辑成功');
                this.back();
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    qrcodeFn(text) {
      this.$refs.qrcodeRef.innerHTML = '';
      new QRCode(this.$refs.qrcodeRef, {
        text: text,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    closePreview() {
      this.previewDialog = false;
    },
    preview(formName) {
      this.previewDialog = true;
      this.infoForm.content = this.$refs.editorBox.editor.txt.html();
      // console.log(this.infoForm.content);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.infoForm.content) {
            this.$message.error('请填写内容');
            return false;
          }
          let isAdd = false;
          if (!this.previewId) {
            isAdd = this.reportRoute.info_id == -1 ? true : false;
            params = Object.assign(this.reportRoute, this.infoForm);
          } else {
            this.infoForm['info_id'] = this.previewId;
          }
          let params = isAdd
            ? this.infoForm
            : Object.assign(this.reportRoute, this.infoForm);
          if (isAdd) {
            imgtext.saveDoctorInfo(params).then((res) => {
              let { code, data } = res;
              if (code == 0) {
                this.$message.success('保存成功');
                this.qrcodeFn(data.url);
                this.previewId = data.info_id;
              }
            });
          } else {
            imgtext.editDoctorInfo(params).then((res) => {
              let { code, data } = res;
              if (code == 0) {
                this.$message.success('编辑成功');
                this.qrcodeFn(data.url);
                this.previewId = data.info_id;
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 删除图片
    delImg() {
      this.infoForm.pic_path = '';
      this.infoForm.pic = '';
    },
    // 上传成功
    handleAvatarSuccess(res, file, fileList) {
      let { code, data } = res;
      if (code === 0) {
        this.infoForm.pic_path = data.path;
        this.infoForm.pic = data.pic;
        this.$message.success('上传图片成功');
        this.$forceUpdate();
      }
    },
    // 上传之前
    beforeUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 200;
          const height = 200;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.add-info {
  .container {
    padding: 20px;
    border-radius: 5px;
    .add-info-box {
      min-height: calc(100vh - 120px);
      background: #fff;
      .info-form {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        text-align: left;
      }
      .icon_img {
        ::v-deep .el-form-item__content {
          height: auto;
          display: flex;
          .icon-box {
            display: flex;
            flex-direction: column;
            p {
              height: 0;
            }
          }
          .el-upload--picture-card {
            width: 200px;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
          }
          .el-upload-list {
            & > li {
              width: 327px;
              height: 267px;
              border-radius: 24px;
            }
          }
        }
        .box {
          position: relative;
          width: 200px;
          &:hover .shadow {
            display: flex;
          }
          img {
            width: 200px;
            height: 200px;
          }
          .shadow {
            position: absolute;
            left: 0;
            top: 0;
            width: 200px;
            height: 200px;
            background-color: rgba(0, 0, 0, 0.6);
            display: none;
          }
          .el-icon-delete {
            font-size: 30px;
            text-align: center;
            cursor: pointer;
            color: #d44747;
          }
        }
      }
      .info-editor {
        width: 70%;
      }
      ::v-deep .el-form-item__content {
        height: auto;
      }
    }
  }
  .qr-code {
    ::v-deep .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>